import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Form, Tab, Tabs } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import wire from '../../assets/Images/wire.jpg';
import wire2 from '../../assets/Images/wire2.jpg';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IProductImages } from '../../models/response/IProductResponse';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import { formatMessage } from '../../translations/format-message';
import RemoveTaskPopupHOC from './hoc/remove-task-popup-hoc';
import './operator.css';
const OperatorAssignTask = (props: any) => {
  const { operatorStore } = useStore();
  const {
    CompleteProcessService,
    completeProcessState,
    GetOperatorService,
    getOperatorState,
    OperatorResponse,
    resetCompleteProcessState,
    resetOperatorResponse,
    removeForAbnormalityState,
    resetRemoveForAbnormalityState,
    operatorTeplarDetails,
  } = operatorStore;

  const { taskId } = useParams<any>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const processName = queryParams.get('processName');
  const processType = queryParams.get('processType');

  const [operatorCount, setOperatorCount] = useState<number>(1);
  const [isBatch, setIsBatch] = useState(true);
  const [startDateTime, setStartDateTime] = useState(null);
  const [timer, setTimer] = useState<number>(0);
  const [isTimerRunning, setIsTimerRunning] = useState<boolean>(false);
  const [isProcessStarted, setIsProcessStarted] = useState(false);

  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(Date.now());
  const [trayIndex, setTrayIndex] = useState(0);
  const [trayHistory, setTrayHistory] = useState<string[]>([]);
  const [selectedTrayId, setSelectedTrayId] = useState<string | null>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [trayId, setTrayId] = useState(''); //remove later
  const productImages: IProductImages[] = OperatorResponse.FileList;
  const handleDecrement = () => {
    setOperatorCount((prev) => Math.max(0, prev - 1));
  };

  const handleIncrement = () => {
    setOperatorCount((prev) => prev + 1);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setOperatorCount(value);
    }
  };

  const getActiveTrayListServiceHandler = () => {
    const currentTray = trayHistory[trayIndex];
    setSelectedTrayId(currentTray);
    setTrayIndex((prevIndex) => (prevIndex + 1) % trayHistory.length);
    GetOperatorService(
      Number(getTenantIdFromLocalStorage()),
      currentTray,
      taskId,
      Number(processType)
    );
  };

  const getSelectedTrayDetails = (trayId: string) => {
    setSelectedTrayId(trayId);
    GetOperatorService(
      Number(getTenantIdFromLocalStorage()),
      trayId,
      taskId,
      Number(processType)
    );
  };

  const handleCompleteProcess = () => {
    const trayIdValue = isBatch ? trayHistory.join(',') : selectedTrayId;
    const submitObj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: ',' + trayIdValue + ',',
      Count: isBatch ? trayHistory.length : 1,
      ProcessId: taskId,
      StartTime: startDateTime,
      EndTime: new Date().toISOString(),
      Duration: timer,
      NoOfOperators: operatorCount,
    };
    // CompleteProcessService(submitObj);
    setIsTimerRunning(false);
    setTimer(0);
    setOperatorCount(1);
    setIsProcessStarted(false);
    handleRemoveTray();
  };

  const handleStartTimer = () => {
    setStartDateTime(new Date().toISOString());
    setIsTimerRunning(true);
    setIsProcessStarted(true);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isTimerRunning) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isTimerRunning]);

  useEffect(() => {
    if (completeProcessState.success) {
      toast.success(formatMessage('added_success'));
      resetCompleteProcessState();
    }
  }, [completeProcessState.success]);

  const handleClick = (index: number) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTime;

      if (
        e.key === 'Shift' ||
        e.key === 'Control' ||
        e.key === 'Alt' ||
        e.key === 'CapsLock' ||
        (e.key.length > 1 && e.key !== 'Enter')
      ) {
        return;
      }

      if (e.key === 'Enter') {
        const cleanedScan = scanBuffer.trim();
        setTrayHistory((prev) => [...prev, cleanedScan]);
        getActiveTrayListServiceHandler();
        setScanBuffer('');
        return;
      }

      if (timeDiff > 100) {
        setScanBuffer(e.key);
      } else {
        setScanBuffer((prev) => prev + e.key);
      }

      setLastKeyTime(currentTime);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [scanBuffer, lastKeyTime]);

  const formatTime = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return [hrs, mins, secs].map((v) => String(v).padStart(2, '0')).join(':');
  };

  const handlePauseTimer = () => {
    setIsTimerRunning(false);
  };

  const handleRemoveTray = () => {
    if (!isBatch || !isProcessStarted) {
      setTrayHistory(() =>
        trayHistory.filter((trayId) => trayId !== selectedTrayId)
      );
    } else {
      setTrayHistory([]);
    }
    resetOperatorResponse();
  };

  const handleRemoveForAbnormality = () => {
    props.removeTaskToggleHandler();
    handlePauseTimer();
  };

  useEffect(() => {
    if (trayHistory.length > 0) {
      setSelectedTrayId(trayHistory[trayHistory.length - 1]);
      getSelectedTrayDetails(trayHistory[trayHistory.length - 1]);
    }
  }, [trayHistory]);

  useEffect(() => {
    resetOperatorResponse();
  }, []);

  useEffect(() => {
    if (removeForAbnormalityState.success) {
      props.removeTaskToggleHandler();
      resetRemoveForAbnormalityState();
      setIsTimerRunning(false);
      setOperatorCount(1);
      setIsProcessStarted(false);
      setTrayHistory((prev) => prev.filter((tray) => tray !== selectedTrayId));
      setIsBatch(true);
      if (!isBatch) {
        setTimer(0);
      }
    }
  }, [removeForAbnormalityState.success]);

  useEffect(() => {
    if (removeForAbnormalityState.error) {
      resetRemoveForAbnormalityState();
    }
  }, [removeForAbnormalityState.error]);

  const buttons = [
    {
      labelKey: isTimerRunning ? 'complete' : 'start',
      className: !isTimerRunning ? 'btn-primary' : 'btn-success',
      onClick: isTimerRunning ? handleCompleteProcess : handleStartTimer,
      isDisabled: trayHistory.length === 0,
    },
    {
      labelKey: 'pause',
      className: 'btn-secondary',
      onClick: handlePauseTimer,
      isDisabled: trayHistory.length === 0 || !isTimerRunning,
    },
    {
      labelKey: 'remove',
      className: 'btn-danger',
      onClick: handleRemoveTray,
      isDisabled: trayHistory.length === 0 || isProcessStarted,
    },
    {
      labelKey: 'remove_for_abnormality',
      className: 'btn-outline-danger',
      onClick: handleRemoveForAbnormality,
      isDisabled: trayHistory.length === 0,
    },
  ];

  const getFontSizeClass = (size: 'small' | 'normal' | 'large') => {
    if (size === 'small') return 'opertor-small-text';
    if (size === 'large') return 'opertor-text-large';
    return 'opertor-normal-text';
  };
  const savedFontSize = localStorage.getItem('fontSize');
  const initialFontSize: 'small' | 'normal' | 'large' =
    savedFontSize === 'small' || savedFontSize === 'large'
      ? savedFontSize
      : 'normal';

  const [fontSizeClass, setFontSizeClass] = useState<string>(
    getFontSizeClass(initialFontSize)
  );
  const [activeSize, setActiveSize] = useState<'small' | 'normal' | 'large'>(
    initialFontSize
  );

  const handleFontSizeChange = (size: 'small' | 'normal' | 'large') => {
    localStorage.setItem('fontSize', size);
    setActiveSize(size);
    setFontSizeClass(getFontSizeClass(size));
  };

  const infoFields = [
    {
      labelKey: 'product_id',
      value: OperatorResponse.ProductName,
    },
    {
      labelKey: 'kishu',
      value: OperatorResponse.Kishu,
    },
    {
      labelKey: 'katashiki',
      value: OperatorResponse.Katashiki,
    },
  ];

  return (
    <div className={`operator-wrapper ${fontSizeClass}`}>
      {/* {props.showRemoveTaskPopup && (
        <RemoveTask
          id=""
          modalClosed={props.removeTaskToggleHandler}
          Count={0}
          ProcessId={'-1'}
          startTime={''}
          Duration={0}
          NoOfOperators={0}
        />
      )} */}
      {(completeProcessState.inProgress ||
        getOperatorState.inProgress ||
        removeForAbnormalityState.inProgress) && (
        <FormLoader
          loading={
            completeProcessState.inProgress ||
            getOperatorState.inProgress ||
            removeForAbnormalityState.inProgress
          }
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav dummy-nav">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xl-6">
            <div className="page_title_wrap">
              <ul className="add-list operator-back">
                <li className="process-chart">
                  <NavLink
                    title={formatMessage('operator_list_detail')}
                    to={RoutesConstants.OperatorListDetail}
                    className="btn btn-secondary"
                    onClick={resetOperatorResponse}
                  >
                    <FormattedMessage id="back" />
                  </NavLink>
                </li>
                <li>
                  {' '}
                  <h1 className="page_title">{processName} </h1>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xl-6">
            <div className="tray-header">
              <div className="card-title d-flex align-items-center justify-content-end  mb-0">
                {/* remove later start */}
                {/* remove later end */}

                <div className="pe-4 d-flex align-items-center">
                  <div className="mx-2">
                    <Form.Select
                      aria-label="Default select example"
                      className="form-control"
                    >
                      <option>Tray ID</option>
                      <option value="1">10900 </option>
                      <option value="2">1090777</option>
                      <option value="3">109098</option>
                    </Form.Select>
                  </div>
                  <div className="me-4">
                    <a
                      className="btn btn-secondary"
                      data-toggle="modal"
                      onClick={() => {
                        setTrayHistory((prev) => [...prev, trayId]);
                        getActiveTrayListServiceHandler();
                        setTrayId('');
                      }}
                      data-testid="modalbtn"
                      data-target="#addUser"
                    >
                      <svg
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-plus m-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                      {/* <FormattedMessage
                                          id={
                                            getTenantIdFromLocalStorage() === '-1'
                                              ? 'add_system_user'
                                              : 'add_operator'
                                          }
                                        /> */}
                      <FormattedMessage id={'add_tray'} />
                    </a>{' '}
                  </div>

                  <ul className="d-flex font-size-increase text-white justify-content-between">
                    <li
                      className={`font-reduce ${activeSize === 'small' ? 'active' : ''}`}
                      onClick={() => handleFontSizeChange('small')}
                    >
                      A-
                    </li>
                    <li
                      className={`font-normal ${activeSize === 'normal' ? 'active' : ''}`}
                      onClick={() => handleFontSizeChange('normal')}
                    >
                      A
                    </li>
                    <li
                      className={`font-increase ${activeSize === 'large' ? 'active' : ''}`}
                      onClick={() => handleFontSizeChange('large')}
                    >
                      A+
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="operator-block"> */}
      {/* <div className="operator-block opertor-small-text"> */}
      <div className="operator-block">
        <div className="card tray-data opertor-dummy">
          <div className="row tray-print">
            <div className="col-lg-6 col-12">
              <div className="row">
                <div className="col-12">
                  <div className="row g-0 tray-data-header">
                    {infoFields.map(({ labelKey, value }, index) => (
                      <div
                        className="col-12 col-sm-6 col-md-4"
                        key={index}
                      >
                        <p className="small text-muted">
                          {formatMessage(labelKey)}
                        </p>
                        <p className="text-dark">{value || '8999'}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="picture_frame tab-opertor-dummy">
                <Tabs
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="textTabBlock "
                >
                  <Tab
                    eventKey="home"
                    title="Wire"
                    className=""
                  >
                    <div className="wire-block">
                      <img
                        src={wire}
                        alt=""
                        className="wire"
                      />
                    </div>
                  </Tab>
                  <Tab
                    eventKey="profile"
                    title="PDF"
                  >
                    <div className="wire-block">
                      <img
                        src={wire2}
                        alt=""
                        className="wire2"
                      />
                    </div>
                  </Tab>
                </Tabs>
                <div className="pic_name_list">
                  {productImages &&
                    productImages.length > 0 &&
                    productImages.map(
                      (productImage: IProductImages, index: number) => {
                        return (
                          <div
                            key={index}
                            title={productImage.Heading}
                            className={`textTabBlock ${
                              activeIndex === index ? 'active' : ''
                            } ${activeIndex !== -1 ? '' : 'disabled-div'}`}
                            onClick={() => handleClick(index)}
                          >
                            <span
                              className="pic_name"
                              onClick={() => handleClick(index)}
                            >
                              {productImages.length > 4 &&
                              productImage.Heading.length > 2
                                ? productImage.Heading.substring(0, 2) + '...'
                                : productImage.Heading}
                            </span>
                          </div>
                        );
                      }
                    )}
                </div>
                {productImages &&
                  productImages.map(
                    (productImage: IProductImages, index: number) => {
                      return (
                        activeIndex === index && (
                          <div key={index}>
                            {productImage.FileType === 'application/pdf' ? (
                              <iframe
                                src={productImage.S3FilePath}
                                title="PDF Viewer"
                                width="100%"
                                height="600px"
                                style={{ border: 'none' }}
                              />
                            ) : (
                              <figure
                                key={index}
                                className="picture"
                              >
                                <img
                                  width="100%"
                                  height="600px"
                                  src={productImage.S3FilePath}
                                  alt={formatMessage('picture_label')}
                                  className=""
                                />
                              </figure>
                            )}
                          </div>
                        )
                      );
                    }
                  )}
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="tableDevices product-img tableDesign">
                <div className="table-responsive">
                  <div className="react-bootstrap-table">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th className="card-title">
                            <FormattedMessage id="Order" />
                          </th>
                          <th className="card-title">
                            <FormattedMessage id="EU" />
                          </th>
                          <th className="card-title">
                            <FormattedMessage id="Group" />
                          </th>
                          <th className="card-title">
                            <FormattedMessage id="Tag Scanner" />
                          </th>
                          <th className="card-title">
                            <FormattedMessage id="Tray ID" />
                          </th>
                          <th className="card-title last-column">
                            <FormattedMessage id="Action" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="highlight">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr className="highlight ">
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="card-data">1234</td>
                          <td className="card-data">123</td>
                          <td className="card-data">ABC</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">98765432109876543210</td>
                          <td className="card-data">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                              ></label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="operator-footer-content ">
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <div className="operator-timer d-flex">
                  <div
                    className={`form-check form-switch d-flex align-items-center  justify-content-between ${
                      isProcessStarted ? 'disable-switch-btn' : ''
                    }`}
                  >
                    <label
                      className="form-check-label batch-input mt-1"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {formatMessage('Batch')}
                    </label>
                    <input
                      className={`form-check-input ${
                        isProcessStarted ? 'pointer-events-none' : ''
                      }`}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      onClick={() => setIsBatch(!isBatch)}
                    />
                    <label
                      className="form-check-label ps-3"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      {formatMessage('single')}
                    </label>
                  </div>

                  <label className="form-check-label ms-3">
                    {formatMessage('operators')}
                  </label>
                  <div
                    className={`input-group operator ${isProcessStarted ? 'cursor-not-allowed' : ''}`}
                  >
                    <button
                      className="btn btn-outline-light pause"
                      type="button"
                      onClick={handleDecrement}
                      disabled={isProcessStarted}
                    >
                      –
                    </button>
                    <input
                      type="number"
                      className="form-control text-center"
                      value={operatorCount > 0 ? operatorCount : 1}
                      onChange={handleChange}
                      min={1}
                      disabled={isProcessStarted}
                    />
                    <button
                      className="btn btn-outline-light"
                      type="button"
                      onClick={handleIncrement}
                      disabled={isProcessStarted}
                    >
                      +
                    </button>
                  </div>
                  <div className="timer d-flex align-items-center">
                    <div className="timer-data">
                      <p>{formatTime(timer)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="d-flex gap-4 flex-wrap justify-content-end  pe-3">
                  {buttons.map(
                    ({ labelKey, className, onClick, isDisabled }, index) => (
                      <div
                        className={`card-title ${isDisabled ? 'cursor-not-allowed' : ''}`}
                        key={index}
                      >
                        <button
                          className={`btn btn-lg ${className} ${isDisabled ? 'disabled' : ''}`}
                          onClick={onClick || undefined}
                          disabled={isDisabled}
                        >
                          {formatMessage(labelKey)}
                        </button>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveTaskPopupHOC(observer(OperatorAssignTask));
